import colors from '../../../../lib/colors'

import { button } from '../../../../component/component'

export default function(o){

  var logo =
    button('OPEN MEMORY BOX')
    .css({
      fontFamily: 'Helvetica Neue LT W06_85 Heavy',
      position: 'absolute',
      display: 'inline-block',
      color: o.colors.yellow,
      left: 0,
    })
    .click(function(e){
      document.location = '/'
    })

  return logo

}



// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/logo/logo.js